import { createStoreContext } from "reusable/mobx-store-utils/storeUtils"
import { makeAutoObservable } from "mobx"
import { apiClient } from "api/trpc/trpc-client"
import MarkdownStore from "reusable/markdown/MarkdownStore"

interface GapFileComponentStoreProps {
   updateMdastNode: (node: any) => void
   isReadOnly: boolean
   attributes: Record<string, string> | undefined
   markdownStore: MarkdownStore
}

export default class GapFileComponentStore {
   sp
   editedName = ''
   editing = false
   fileName = ''
   rawFileName = ''
   downloadUrl: string | null = null
   
   constructor(sp: GapFileComponentStoreProps) {
      makeAutoObservable(this)
      this.sp = sp
      this.fileName = sp.attributes?.name || ''
      this.rawFileName = sp.attributes?.rawFileName || ''
   }

   getDownloadUrl = async () => {
      const url = await apiClient.markdown.getFileDownloadUrl.query({ fileName: this.rawFileName, entityId: this.sp.markdownStore.sp.id })
      this.downloadUrl = url
   }
   
   onTextfieldUpdate = (e: React.ChangeEvent<HTMLInputElement>) => {
      this.editedName = e.target.value
   }

   handleCancel = () => {
      this.editing = false
   }

   handleEditClick = () => {
      this.editing = true
      this.editedName = this.fileName
   }

   handleLinkClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
      if (!this.sp.isReadOnly) {
         e.preventDefault()
         this.handleEditClick()
      }
   }

   handleSave = () => {
      this.sp.updateMdastNode({
         attributes: {
            ...this.sp.attributes,
            name: this.editedName,
         },
      })
      this.fileName = this.editedName
      this.editing = false
   }
}

export const { Provider: GapFileComponentStoreProvider, useProvidedStore: useGapFileComponentStore } = createStoreContext(GapFileComponentStore)
